export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SET_MEALS = 'SET_MEALS';
export const SET_LOADING = 'SET_LOADING';
export const SET_MEAL = 'SET_MEAL';
